/* eslint-disable object-curly-newline */
import { createTheme } from '@mui/material/styles';
// import * as brandColors from './brandColors';

import { dataDisplayCustomizations } from './customizations/dataDisplay';
import { feedbackCustomizations } from './customizations/feedback';
import { inputsCustomizations } from './customizations/inputs';
import { navigationCustomizations } from './customizations/navigation';
import { surfacesCustomizations } from './customizations/surfaces';
import {
  colorSchemes,
  shadows,
  shape,
  typography,
} from './themePrimitives';

// export const brandPalette = {
//   primary: {
//     ...brandColors.primary,
//     contrastText: '#fff',
//   },
//   secondary: {
//     ...brandColors.secondary,
//     contrastText: '#fff',
//   },
//   error: {
//     ...brandColors.danger,
//     contrastText: '#fff',
//   },
//   warning: {
//     ...brandColors.complementary,
//     contrastText: '#fff',
//   },
//   success: {
//     ...brandColors.success,
//     contrastText: '#fff',
//   },
//   info: {
//     ...brandColors.blueGrey,
//     contrastText: '#fff',
//   },
//   grey: {
//     ...brandColors.grey,
//   },
// };

// const palette = {
//   ...brandPalette,
//   background: {
//     default: '#F6F6F6',
//     paper: '#FFFFFF',
//   },
//   text: {
//     primary: brandColors.blueGrey[900],
//     secondary: brandColors.grey[700],
//   },
// };

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 1000,
      lg: 1400,
      xl: 2000,
    },
  },
  // typography: {
  //   fontWeight: 300,
  //   useNextVariants: true,
  //   fontFamily: 'Lato',
  //   h4: { fontSize: 28 },
  //   h5: { fontSize: 18 },
  // },
  cssVariables: {
    colorSchemeSelector: 'data-mui-color-scheme',
    cssVarPrefix: 'template',
  },
  colorSchemes, // Recently added in v6 for building light & dark mode app, see https://mui.com/material-ui/customization/palette/#color-schemes
  typography,
  shadows,
  shape,
  components: {
    ...inputsCustomizations,
    ...dataDisplayCustomizations,
    ...feedbackCustomizations,
    ...navigationCustomizations,
    ...surfacesCustomizations,
    MuiCssBaseline: {
      styleOverrides: (themeParam) => ({
        html: {
          minHeight: '100%',
          backgroundColor: (themeParam.vars || themeParam).palette.background.default,
        },
        body: {
          minHeight: '100%',
          backgroundColor: (themeParam.vars || themeParam).palette.background.default,
          color: (themeParam.vars || themeParam).palette.text.primary,
          transition: 'background-color 200ms ease, color 200ms ease',
        },
        '#root': {
          minHeight: '100vh',
          backgroundColor: 'transparent',
        },
        '.MuiPickersSectionList-root': {
          padding: '9.5px 0 !important', // replace with your desired spacing
        },
      }),
    },
    MuiCard: {
      styleOverrides: {
        root: ({ theme: themeParam }) => ({
          padding: themeParam.spacing(2),
        }),
      },
    },
    // ...themeComponents,
    // MuiCssBaseline: {
    //   styleOverrides: {
    //     body: { fontFamily: '"Lato","Helvetica","Arial",sans-serif' },
    //   },
    // },
    // MuiTextField: {
    //   defaultProps: {
    //     variant: 'outlined',
    //     autoComplete: 'off',
    //   },
    // },
    // MuiFilledInput: {
    //   defaultProps: { size: 'small' },
    // },
    // MuiInput: {
    //   defaultProps: { autoComplete: 'off' },
    //   styleOverrides: {
    //     input: { fontSize: '14px' },
    //   },
    // },
    // MuiAvatar: {
    //   styleOverrides: {
    //     colorDefault: {
    //       color: brandColors.grey[500],
    //       backgroundColor: brandColors.grey[200],
    //     },
    //   },
    // },
    // MuiListItemText: {
    //   styleOverrides: { root: { padding: '0 16px' } },
    // },
    // MuiTableCell: {
    //   styleOverrides: {
    //     root: {
    //       padding: '.5em 1em',
    //       minWidth: 120,
    //     },
    //   },
    // },
    // MuiButton: {
    //   styleOverrides: {
    //     // contained: {
    //     //   backgroundColor: '#F8F8F8',
    //     //   boxShadow: 'none',
    //     //   color: brandColors.primary[600],
    //     //   fontWeight: 900,
    //     //   textTransform: 'none',
    //     //   '&:hover': {
    //     //     backgroundColor: brandColors.secondary[50],
    //     //     boxShadow: 'none',
    //     //     textDecoration: 'none',
    //     //   },
    //     // },
    //     // containedPrimary: {
    //     //   color: 'white',
    //     //   textTransform: 'none',
    //     //   '&:hover': { color: 'white' },
    //     // },
    //     // containedSecondary: { background: brandColors.secondary.main },
    //     // textSecondary: { color: brandColors.secondary.main },
    //     // outlinedSecondary: {
    //     //   color: brandColors.secondary.main,
    //     //   borderColor: brandColors.secondary.main,
    //     // },
    //     text: { textTransform: 'none' },
    //   },
    // },
    // MuiAppBar: {
    //   styleOverrides: {
    //     colorPrimary: () => ({
    //       backgroundColor: theme.palette.primary.main,
    //       color: theme.palette.primary.contrastText,
    //       border: `1px solid ${theme.palette.primary.main}`,
    //     }),
    //   },
    // },
    // MuiCard: {
    //   styleOverrides: { root: { marginBottom: 10 } },
    // },
    // MuiTypography: {
    //   styleOverrides: {
    //     root: { fontWeight: 300 },
    //     h1: {
    //       fontSize: '3em',
    //       lineHeight: '1.15em',
    //     },
    //     h2: { fontSize: '2.2em' },
    //     h3: {
    //       fontSize: '1.825em',
    //       margin: '20px 0 10px',
    //       lineHeight: '1.4em',
    //     },
    //     h4: {
    //       marginTop: '10px',
    //       marginBottom: '10px',
    //       fontSize: '1.3em',
    //     },
    //     h5: {
    //       fontSize: '1.25em',
    //       lineHeight: '1.4em',
    //     },
    //     subtitle1: { textTransform: 'unset' },
    //     body1: {
    //       fontSize: '1em',
    //       fontWeight: '300',
    //       lineHeight: 1.5,
    //       letterSpacing: '.5px',
    //     },
    //     body2: {
    //       fontSize: '.875rem',
    //       fontWeight: '300',
    //       lineHeight: 1.5,
    //       letterSpacing: '.5px',
    //     },
    //     overline: {
    //       fontSize: '.8em',
    //       fontWeight: 500,
    //       margin: '10px 0',
    //       lineHeight: 1,
    //     },
    //     button: { textTransform: 'none' },
    //   },
    // },
    // MuiBadge: {
    //   styleOverrides: { badge: { fontWeight: 600 } },
    // },
    // MuiFab: {
    //   styleOverrides: {
    //     root: {
    //       backgroundColor: brandColors.grey[200],
    //       color: brandColors.grey.main,
    //     },
    //   },
    // },
    // MuiTab: {
    //   styleOverrides: { root: { textTransform: 'none' } },
    // },
    // MuiTabs: {
    //   styleOverrides: {
    //     indicator: { backgroundColor: 'transparent' },
    //     scroller: { overflowX: 'auto' },
    //   },
    // },
    // MuiPaper: {
    //   styleOverrides: {
    //     elevation3: {
    //       boxShadow: '0 0.375rem 1.5rem 0 rgba(140, 152, 164, 0.125) !important',
    //       border: `1px solid ${brandColors.grey[200]}`,
    //     },
    //     elevation4: {
    //       boxShadow: '0px 0px 1px -1px rgba(0,0,0,0.2), 0px -5px 0px 0px rgba(0,0,0,0.14), 0px 1px 16px 0px rgba(0,0,0,0.12)',
    //       border: `1px solid ${brandColors.grey[200]}`,
    //     },
    //   },
    // },
    // MuiStepIcon: {
    //   styleOverrides: {
    //     text: {
    //       stroke: 'white',
    //       fontSize: '0.8rem',
    //     },
    //   },
    // },
    // MuiStepper: {
    //   styleOverrides: { root: { padding: '1em' } },
    // },
    // MuiChip: {
    //   styleOverrides: { root: { backgroundColor: brandColors.grey[200] } },
    // },
  },
});

export default theme;
